import Vue from 'vue'

import AddressBook from '@/AddressBookList/AddressBook'
import OrgBook from '@/AddressBookList/OrgBook'
import OrgClassicBook from '@/AddressBookList/OrgClassicBook'
import PadBook from '@/AddressBookList/PadBook'
import AddressList from '@/AddressBookList/AddressList'
import AddressDormList from '@/AddressBookList/DormList'
import AttendancePeriods from '@/AddressBookList/AttendancePeriods'
import PadList from '@/AddressBookList/PadList'
import CustomRoleGroup from '@/AddressBookList/CustomRoleGroup'
import QingtianOrgBook from '@/AddressBookList/QingtianOrgBook'
import GuardianBook from '@/AddressBookList/GuardianBook'

import MoreIdeaUI from 'more-idea-ui'
import imageCroppie from '@/components/imageCroppie'
import 'more-idea-ui/lib/theme-default/index.css'
import './../../node_modules/croppie/croppie.css'

import showDownloading from '@/utils/showDownloading'

Vue.use(showDownloading)
Vue.use(MoreIdeaUI)

// 修改fastclick源码，处理ios11以上文本框focus延迟问题
require('@/utils/Fastclick')

Vue.use(AddressBook)
Vue.use(OrgBook)
Vue.use(PadBook)
Vue.use(AddressList)
Vue.use(AddressDormList)
Vue.use(AttendancePeriods)
Vue.use(PadList)
Vue.use(CustomRoleGroup)
Vue.use(QingtianOrgBook)
Vue.use(OrgClassicBook)
Vue.use(GuardianBook)

imageCroppie.install(Vue)
if ('addEventListener' in document) {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      window.FastClick && window.FastClick.attach(document.body)
    },
    false
  )
}
